import {DmResource} from './DmResource';
export default DmResource;
